import React from 'react';
import './index.less';

interface SkeletonProps {
    loading: boolean;
    children: React.ReactNode;
    active?: boolean;
    height?: number | string;
    backgroundColor?: string;
    style?: React.CSSProperties;
}

const SkeletonRender = (props: SkeletonProps) => {
    const {
        loading,
        children,
        height = '100%',
        active = false,
        backgroundColor = 'var(--background-btn-secondary)',
    } = props;

    return loading ? (
        <div
            className={`skeleton ${active && loading ? 'skeleton-active' : ''} ${loading ? 'skeleton-loading' : ''}`}
            style={{ height: typeof height === 'number' ? `${height}px` : height, ...props.style }}
        >
            <div
                className="skeleton-content"
                style={{
                    backgroundColor,
                }}
            />
        </div>
    ) : (
        <>{children}</>
    );
};

export default SkeletonRender;
